<template>
  <div class="popover-content">

    <div v-for="(product, index) in not_draft_products" :key="product.id" class="columns is-size-5 is-vcentered is-mobile gray-bottom-border">
      <div class="column is-4 has-text-centered is-flex is-align-items-center is-justify-content-center">
        <figure class="image is-2by1 is-thumbnail" v-if="product.thumbnail_url != ''" style="height: 100%;">
          <img :src="getItemThumbnail(product)" />
        </figure>
        <figure class="image is-thumbnail" v-else style="height: 100%;">
          <img :src="getItemThumbnail(product)" />
        </figure>
      </div>
      <div class="column is-4 is-relative is-hidden-mobile">
        <div class="text-wrapper is-inline-block">
          <span class="position">{{getProductName(product.product)}}</span>
          <span class="position">Määrä {{product.amount}}</span>
        </div>
      </div>
      <div class="column is-4 has-text-right is-relative is-hidden-mobile">
        <div class="text-wrapper is-inline-block ml-3">
          <span class="position">{{ (getVolumeDiscountPerCupSize(product.product, product.material) * product.amount).toFixed(2)}} €</span>
        </div>
      </div>
      <div class="column is-4 has-text-right is-hidden-tablet">
        <div class="text-wrapper">
          <span class="position">x {{product.amount}} = {{ (getVolumeDiscountPerCupSize(product.product, product.material) * product.amount).toFixed(2)}} €</span>
        </div>
      </div>
    </div>

    <div v-for="(form, index) in non_draft_forms" :key="index" class="columns is-size-5 is-vcentered is-mobile is-multiline">
      <div class="column is-4 has-text-centered">
        <figure class="image is-thumbnail">
          <img :src="getItemThumbnail(form)" />
        </figure>
      </div>
      <div class="column is-4 has-text-centered is-relative is-hidden-mobile">
        <div class="text-wrapper is-inline-block ml-3">
          <span class="position">x {{form.amount}}</span>
        </div>
      </div>
      <div class="column is-4 is-relative is-hidden-mobile">
        <div class="text-wrapper is-inline-block ml-3">
          <span class="position"> {{(getVolumeDiscountPerCupSize(form.product) * this.$store.getters.getItemsTotalAmountByProduct(form.product)).toFixed(2)}} €</span>
        </div>
      </div>

      <div class="column is-4 has-text-centered">
        <p class="font-13">
        Suunnittelupalvelu
        </p>
      </div>
      <div class="column is-4 is-relative is-hidden-mobile has-text-centered">
        <div class="text-wrapper is-inline-block ml-3">
          <span class="position">x 1</span>
        </div>
      </div>
      <div class="column is-4 has-text-centered is-relative is-hidden-mobile">
        <div class="text-wrapper is-inline-block ml-3">
          <span class="position">{{this.$store.getters.getDesignServiceFee.price}}€</span>
        </div>
      </div>
    </div>

    <div class="columns is-mobile" v-if="additionalChargeCost!=0">
      <div class="column is-4 has-text-left">
        <p class="font-13">Pientoimituslisä</p>
      </div>
      <div class="column is-4 is-offset-4 has-text-right">
        <p class="font-13">{{ additionalChargeCost.toFixed(2) }} €</p>
      </div>
    </div>

    <div class="columns is-mobile" v-if="transportCost!=0">
      <div class="column is-4 has-text-left">
        <p class="font-13">Toimituskulut</p>
      </div>
      <div class="column is-4 is-offset-4 has-text-right">
        <p class="font-13">{{ transportCost.toFixed(2) }} €</p>
      </div>
    </div>

    <div class="columns is-mobile">
      <div class="column is-4 has-text-left">
        <p class="font-13">{{ this.$t("message.modals.cartModal.totalText") }}</p>
      </div>
      <div class="column is-4 is-offset-4 has-text-right">
        <p class="font-13"><b>{{ finalPriceNoVat }} €</b></p>
      </div>
    </div>
    <div class="columns is-mobile" v-for="vat in vatBreakdown" :key="vat.rate">
      <div class="column is-4 has-text-left">
        <p class="font-13">ALV {{ vat.rate }}%:</p>
      </div>
      <div class="column is-4 is-offset-4 has-text-right">
        <p class="font-13"><b>{{ vat.withVat.toFixed(2) }} €</b></p>
      </div>
    </div>
    <div class="columns is-mobile" v-if="hasMultipleVatRates">
      <div class="column is-4 has-text-left">
        <p class="font-13">ALV {{ this.$t("message.pages.cartPage.totalText") }}:</p>
      </div>
      <div class="column is-4 is-offset-4 has-text-right">
        <p class="font-13"><b>{{ finalPrice }} €</b></p>
      </div>
    </div>
    <div class="columns is-mobile">
      <div class="column is-6 has-text-left">
        <button
          :disabled="getSavedItems().length + getNonDraftOrderForms().length == 0"
          class="pyroll-button-rectangle"
          @click="resetCart()"
        >
          <span>{{ this.$t("message.modals.cartModal.resetButtonText") }}</span>
      </button>
      </div>
      <div class="column is-6 has-text-right">
        <button
          :disabled="getSavedItems().length + getNonDraftOrderForms().length == 0"
          class="pyroll-button dark-blue-bg font-white"
          @click="goToCart()"
        >
          <span>{{ this.$t("message.modals.cartModal.goCartButtonText") }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import asModalDialogMixin from "@/helpers/modalMixing"
import cartMixin from "@/mixins/cartMixin";
import pricingMixin from "@/mixins/pricingMixin";
import { mapGetters } from "vuex";

export default {
  name: 'cartModal',
  mixins: [
    asModalDialogMixin,
    cartMixin,
    pricingMixin
  ],
  data() {
    return {
      publicPath: process.env.BASE_URL,
      billingCharge: false,
    }
  },
  methods: {
    ...mapGetters({
      getVoucher: "getVoucher",
      getFixedVoucher: "getFixedVoucher"
    }),
    getProductName(id) {
      let product = this.$store.getters.getProductById(id)
      return product.name
    }
  },
  computed: {
    account() {
      return this.$store.getters.getAccountInfo
    },
  }
}
</script>

<style lang="scss" scoped>
.is-layout-fixed{
  position: fixed !important;
}

.mobile-modal {
  .buttons {
    right: 0;
    top: 0;
    position: absolute;
  }
}

.popover-content {
  z-index: 10;
  position: absolute;
  background-color: white;
  width: 400px;
  right: 0;
  padding-top: 20px;
  padding-bottom: 20px;
  padding-right: 50px;
  padding-left: 50px;
  border: 1px solid black;
  top: 80px;
  max-height: 500px;
  overflow: hidden;
  overflow-y: scroll;

  @media (max-width: 768px) {
    width: 100%;
    right: 0;
  }
  button {
    width: 150px;
  }
}

.box-text {
  white-space: pre-wrap;
}

.box-text-wrapper {
  text-align: center;
}

.text-wrapper span {
  display: block;
  font-size: 12px;
  text-align: left;
}


.cart-logo-small {
  background-size: contain;
  width: 20px;
  height: 20px;
  position: absolute;
  &.portrait {
    right: 5px;
    bottom: 5px;
    width: 15px;
    height: 15px;
  }
  &.landscape {
    right: 8px;
    bottom: 8px;
    @media (max-width: 768px) {
      right: 5px;
      bottom: 5px;
    }
  }
}

span.position {
  @media (max-width: 768px) {
    font-size: 12px;
  }
}

.gray-bottom-border {
  border-bottom: 2px solid #D0D3D4;
}
</style>
